export default "__VITE_ASSET__zoO01HJ0__"